import { useUpdateUnbalanceMutation, successSnack, errorSnack } from 'features'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux'
import { GridActionsCellItem } from 'vendor/x-data-grid'

export const GridResendBouserInvite = (_props) => {
  const { unbalanceid } = _props

  const [resendRequest, { isLoading }] = useUpdateUnbalanceMutation()

  const dispatch = useDispatch()

  const handleResendRequest = async () => {
    resendRequest({ unbalanceid: unbalanceid })
      .unwrap()
      .then((res) => {
        dispatch(successSnack({ message: 'Corrección de desbalance exitosa' }))
      })
      .catch((error) => {
        dispatch(
          errorSnack({ message: 'Error en la corrección de desbalance' })
        )
      })
  }

  return (
    <GridActionsCellItem
      icon={<FontAwesomeIcon icon={faCheckCircle} size={'1x'} fixedWidth />}
      label=""
      color="primary"
      onClick={handleResendRequest}
    />
  )
}
